"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.seal");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _CusromUpload = _interopRequireDefault(require("@/components/uploadImg/CusromUpload.vue"));
var _editorForVue = require("@wangeditor/editor-for-vue");
var _ossUpload = require("@/utils/ossUpload");
var _ActivitySelectionPopup = _interopRequireDefault(require("@/views/operationManagement/appRenovation/component/components/ActivitySelectionPopup.vue"));
var _activityResponse = _interopRequireDefault(require("@/components/ActivityResponse/activityResponse"));
var _marketingCampaign = require("@/api/marketingCampaign");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import upload from './component/upload.vue'
var _default = exports.default = {
  name: 'SuperPopup',
  components: {
    upload: _CusromUpload.default,
    Editor: _editorForVue.Editor,
    Toolbar: _editorForVue.Toolbar,
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  mixins: [_activityResponse.default],
  props: {
    actionType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      btnBoole: true,
      rankStartBoole: false,
      signStartBoole: false,
      unionCodeBoole: false,
      indexTypeBoole: false,
      rankStatus: '',
      eventsType: 'add',
      dialogVisible: false,
      ruleForm: {
        actionType: '',
        rankSwitch: null,
        unionCode: null,
        indexType: '',
        rankLimit: '',
        title: '',
        mainPic: '',
        color: '',
        rankStartTime: '',
        // 活动开始时间
        rankEndTime: '',
        // 活动结束时间
        signStartTime: '',
        // 报名开始时间
        signEndTime: '',
        // 报名结束时间
        deadlineTime: '',
        signTips: '',
        // 报名提示
        activityPage: '',
        // 活动跳转入口
        rewardList: [{
          level: 1,
          // 奖励层级
          start: null,
          // 奖励范围开始值
          end: null,
          // 奖励范围结束值
          value: null // 奖励金额
        }],
        ruleTips: '' // 活动规则文案
      },
      firstObj: {
        rankStartTime: '',
        rankEndTime: '',
        signStartTime: '',
        signEndTime: '',
        unionCode: ''
      },
      rules: {
        rankSwitch: [{
          required: true,
          message: '请选择活动状态',
          trigger: 'change'
        }],
        unionCode: [{
          required: true,
          message: '请选择活动渠道',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'change'
        }],
        mainPic: [{
          required: true,
          message: '请上传头图',
          trigger: 'change'
        }],
        color: [{
          required: true,
          message: '请输入活动颜色',
          trigger: 'change'
        }],
        indexType: [{
          required: true,
          message: '请选择统计类型',
          trigger: 'change'
        }],
        rankLimit: [{
          required: true,
          message: '请输入奖励门槛',
          trigger: 'change'
        }],
        rankStartTime: [{
          required: true,
          message: '请选择活动开始时间',
          trigger: 'change'
        }],
        rankEndTime: [{
          required: true,
          message: '请选择活动结束时间',
          trigger: 'change'
        }],
        signStartTime: [{
          required: true,
          message: '请选择报名开始时间',
          trigger: 'change'
        }],
        signEndTime: [{
          required: true,
          message: '请选择报名结束时间',
          trigger: 'change'
        }],
        deadlineTime: [{
          required: true,
          message: '请选择数据统计截止时间',
          trigger: 'change'
        }],
        signTips: [{
          required: true,
          message: '请输入报名提示',
          trigger: 'change'
        }],
        activityPage: [{
          required: true,
          message: '请输入活动跳转入口',
          trigger: 'change'
        }],
        ruleTips: [{
          required: true,
          message: '请输入活动规则文案',
          trigger: 'change'
        }],
        // 新增：逐项校验 rewardList 中每一项
        rewardList: [{
          validator: function validator(rule, value, callback) {
            for (var i = 0; i < value.length; i++) {
              var item = value[i];
              if (!item.start && item.start !== 0) {
                return callback(new Error("\u7B2C".concat(i + 1, "\u4E2A\u533A\u95F4\uFF1A\u8BF7\u8F93\u5165\u5F00\u59CB\u540D\u6B21")));
              }
              if (!item.end && item.end !== 0) {
                return callback(new Error("\u7B2C".concat(i + 1, "\u4E2A\u533A\u95F4\uFF1A\u8BF7\u8F93\u5165\u7ED3\u675F\u540D\u6B21")));
              }
              if (!item.value && item.value !== 0) {
                return callback(new Error("\u7B2C".concat(i + 1, "\u4E2A\u533A\u95F4\uFF1A\u8BF7\u8F93\u5165\u5956\u52B1\u91D1\u989D")));
              }
              if (Number(item.start) > Number(item.end)) {
                return callback(new Error("\u7B2C".concat(i + 1, "\u4E2A\u533A\u95F4\uFF1A\u5F00\u59CB\u540D\u6B21\u4E0D\u80FD\u5927\u4E8E\u7ED3\u675F\u540D\u6B21")));
              }
            }
            callback();
          },
          trigger: 'change'
        }],
        rewardStart: [{
          required: true,
          message: '请输入开始名次',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '名次必须大于0',
          trigger: 'blur'
        }],
        rewardEnd: [{
          required: true,
          message: '请输入结束名次',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 1,
          message: '名次必须大于0',
          trigger: 'blur'
        }],
        rewardValue: [{
          required: true,
          message: '请输入奖励金额',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '奖励金额不能为负数',
          trigger: 'blur'
        }]
      },
      editor: null,
      mode: 'default',
      // or 'simple'
      toolbarConfig: {},
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: function () {
              var _customUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, insertFn) {
                var pictureUrl, _t;
                return (0, _regenerator2.default)().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      _context.p = 0;
                      _context.n = 1;
                      return (0, _ossUpload.uploadOSS)(file);
                    case 1:
                      pictureUrl = _context.v;
                      insertFn(pictureUrl);
                      _context.n = 3;
                      break;
                    case 2:
                      _context.p = 2;
                      _t = _context.v;
                      console.log('error ->', _t);
                    case 3:
                      return _context.a(2);
                  }
                }, _callee, null, [[0, 2]]);
              }));
              function customUpload(_x, _x2) {
                return _customUpload.apply(this, arguments);
              }
              return customUpload;
            }()
          }
        }
      },
      val: ''
    };
  },
  methods: {
    openDialog: function openDialog(data) {
      this.eventsType = data.type;
      if (data.type === 'edit') {
        // console.log(data.rankStatus)
        this.rankStatus = data.rankStatus;
        this.getRank(data.id);
      }
      this.dialogVisible = true;
      console.log(this.actionType, '===============');
    },
    onPictureAddress: function onPictureAddress(data) {
      this.ruleForm[data.name] = data.pictureUrl;
    },
    submitForm: function submitForm() {
      var _this = this;
      var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ruleForm';
      console.log(new Date(this.ruleForm.rankStartTime).getTime());
      console.log(new Date(this.ruleForm.rankEndTime).getTime());
      if (!this.btnBoole) {
        this.$message({
          message: '当前活动已结束，暂不支持编辑活动信息',
          type: 'error'
        });
        return;
      }
      this.$refs[formName].validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(valid) {
          return (0, _regenerator2.default)().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                if (!(new Date(_this.ruleForm.rankStartTime).getTime() >= new Date(_this.ruleForm.rankEndTime).getTime())) {
                  _context2.n = 2;
                  break;
                }
                _this.$message({
                  message: '活动开始时间不能大于活动结束时间',
                  type: 'error'
                });
                return _context2.a(2);
              case 2:
                if (!(new Date(_this.ruleForm.signStartTime).getTime() >= new Date(_this.ruleForm.signEndTime).getTime())) {
                  _context2.n = 3;
                  break;
                }
                _this.$message({
                  message: '报名开始时间不能大于报名结束时间',
                  type: 'error'
                });
                return _context2.a(2);
              case 3:
                if (!(new Date(_this.ruleForm.signStartTime).getTime() > new Date(_this.ruleForm.rankEndTime).getTime())) {
                  _context2.n = 4;
                  break;
                }
                _this.$message({
                  message: '报名开始时间不能大于活动结束时间',
                  type: 'error'
                });
                return _context2.a(2);
              case 4:
                if (!(new Date(_this.ruleForm.signEndTime).getTime() > new Date(_this.ruleForm.rankEndTime).getTime())) {
                  _context2.n = 5;
                  break;
                }
                _this.$message({
                  message: '报名结束时间不能大于活动结束时间',
                  type: 'error'
                });
                return _context2.a(2);
              case 5:
                if (!(_this.eventsType === 'edit')) {
                  _context2.n = 7;
                  break;
                }
                _context2.n = 6;
                return _this.updateRank();
              case 6:
                _context2.n = 8;
                break;
              case 7:
                _context2.n = 8;
                return _this.saveRank();
              case 8:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resetForm: function resetForm() {
      var formName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ruleForm';
      this.$refs[formName].resetFields();
    },
    // 新增
    saveRank: function () {
      var _saveRank = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              console.log(this.ruleForm);
              this.ruleForm.actionType = this.actionType;
              _context3.n = 1;
              return (0, _marketingCampaign.saveRankApi)(this.ruleForm);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.$emit('fresh');
                this.handleClose();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveRank() {
        return _saveRank.apply(this, arguments);
      }
      return saveRank;
    }(),
    // 编辑
    updateRank: function () {
      var _updateRank = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var obj, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              obj = (0, _objectSpread2.default)({}, this.ruleForm);
              if (this.firstObj.rankStartTime === obj.rankStartTime) {
                delete obj.rankStartTime;
              }
              if (this.firstObj.rankEndTime === obj.rankEndTime) {
                delete obj.rankEndTime;
              }
              if (this.firstObj.signStartTime === obj.signStartTime) {
                delete obj.signStartTime;
              }
              if (this.firstObj.signEndTime === obj.signEndTime) {
                delete obj.signEndTime;
              }
              if (this.unionCodeBoole) {
                delete obj.unionCode;
              }
              if (this.indexTypeBoole) {
                delete obj.indexType;
              }
              _context4.n = 1;
              return (0, _marketingCampaign.updateRankApi)(obj);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                this.$emit('upFresh');
                this.handleClose();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function updateRank() {
        return _updateRank.apply(this, arguments);
      }
      return updateRank;
    }(),
    onAddRewardRange: function onAddRewardRange() {
      this.ruleForm.rewardList.push({
        level: this.ruleForm.rewardList.length + 1,
        start: null,
        end: null,
        value: null
      });
    },
    onDeleteRewardRange: function onDeleteRewardRange(index) {
      if (this.ruleForm.rewardList.length <= 1) {
        return false;
      }
      this.ruleForm.rewardList.splice(index, 1);
    },
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    handleClose: function handleClose() {
      this.ruleForm = {
        actionType: '',
        indexType: '',
        rankLimit: '',
        rankSwitch: null,
        unionCode: null,
        title: '',
        mainPic: '',
        color: '',
        rankStartTime: '',
        // 活动开始时间
        rankEndTime: '',
        // 活动结束时间
        signStartTime: '',
        // 报名开始时间
        signEndTime: '',
        // 报名结束时间
        deadlineTime: '',
        signTips: '',
        // 报名提示
        activityPage: '',
        // 活动跳转入口
        rewardList: [{
          level: 1,
          // 奖励层级
          start: null,
          // 奖励范围开始值
          end: null,
          // 奖励范围结束值
          value: null // 奖励金额
        }],
        ruleTips: '' // 活动规则文案
      };
      this.btnBoole = true;
      this.rankStartBoole = false;
      this.signStartBoole = false;
      this.unionCodeBoole = false;
      this.indexTypeBoole = false;
      this.resetForm();
      this.dialogVisible = false;
    },
    // 选择活动
    onOfficialEvent: function onOfficialEvent() {
      this.$refs.activitySelectionPopup.open();
    },
    // 自定义多功能回传
    onSelectEvents: function onSelectEvents(data) {
      var resData = this.response(data);
      this.ruleForm.activityPage = resData.openUrl;
      // this.form.ActivityName = resData.name
    },
    // 详情
    getRank: function () {
      var _getRank = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var res;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _marketingCampaign.getRankApi)({
                rankId: id
              });
            case 1:
              res = _context5.v;
              console.log(this.rankStatus, res.data.signStartTime, res.data.signEndTime);
              if (this.rankStatus === 0) {
                if (new Date().getTime() > new Date(res.data.signStartTime).getTime() && new Date().getTime() < new Date(res.data.signEndTime).getTime()) {
                  this.signStartBoole = true;
                }
              } else if (this.rankStatus === 1) {
                if (new Date().getTime() < new Date(res.data.signStartTime).getTime()) {
                  // 报名未开始
                  this.rankStartBoole = true;
                  this.unionCodeBoole = true;
                  this.indexTypeBoole = true;
                } else if (new Date().getTime() > new Date(res.data.signStartTime).getTime() && new Date().getTime() < new Date(res.data.signEndTime).getTime()) {
                  // 报名开始
                  this.signStartBoole = true;
                  this.unionCodeBoole = true;
                  this.indexTypeBoole = true;
                  this.rankStartBoole = true;
                } else if (new Date().getTime() > new Date(res.data.signEndTime).getTime()) {
                  // 报名结束
                  this.signStartBoole = true;
                  this.unionCodeBoole = true;
                  this.indexTypeBoole = true;
                  this.rankStartBoole = true;
                }
              } else if (this.rankStatus === 2 || this.rankStatus === 3) {
                this.btnBoole = false;
              }
              this.unionCodeBoole = true;
              this.indexTypeBoole = true;
              this.firstObj.rankStartTime = res.data.rankStartTime;
              this.firstObj.rankEndTime = res.data.rankEndTime;
              this.firstObj.signStartTime = res.data.signStartTime;
              this.firstObj.signEndTime = res.data.signEndTime;
              this.firstObj.unionCode = res.data.unionCode;
              this.ruleForm = res.data;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getRank(_x4) {
        return _getRank.apply(this, arguments);
      }
      return getRank;
    }()
  }
};